import React from 'react';
import { DesignerLayout } from './DesignerLayout';
import { DesignerSteps, STEP_NAMES, useDesignerSteps } from './DesignerSteps';
export interface DesignerState {
  // Step 1
  eventName: string;
  eventType: string;
  locationType: string;
  location: string;
  attendees: string;
  length: string;
  date: string;
  // Step 2
  goals: string[];
  successCriteria: string;
  // Step 3
  audienceType: string;
  energyLevel: string;
  format: string;
  comfortLevel: string;
  foodAlcohol: string;
  // Step 4
  learningThemes: string[];
  wellnessActivities: string[];
  constraints: string;
  // Step 5
  name: string;
  email: string;
  company: string;
  role: string;
  planningFor: string;
  brandedHub: string;
}
export function DesignerFlow() {
  const {
    step,
    data,
    updateData,
    nextStep,
    prevStep
  } = useDesignerSteps();
  return <DesignerLayout currentStep={step} totalSteps={5} stepName={STEP_NAMES[step - 1]} data-id="element-2465">
      <DesignerSteps step={step} data={data} updateData={updateData} nextStep={nextStep} prevStep={prevStep} data-id="element-2466" />
    </DesignerLayout>;
}